import { Component, OnInit, Input } from '@angular/core';
import { formatNumber } from '../../../utils/common';
@Component({
  selector: 'icc-total-wechat-fans',
  templateUrl: './icc-total-wechat-fans.component.html',
  styleUrls: ['./icc-total-wechat-fans.component.less'],
})
export class IccTotalWechatFansComponent implements OnInit {
  constructor() {}

  // 数据源
  @Input() data: {
    follow: number; // 累计关注粉丝数
    unfollow: number; // 取关数
    new: number; // 新关注数
    // 同上个周期的比较，正为上升，负为下降
    compare: {
      follow: number;
      unfollow: number;
      new: number;
    };
  };

  viewData: {
    follow: string;
    unfollow: string;
    new: string;
    compare: {
      follow: number;
      unfollow: number;
      new: number;
    };
  };

  ngOnInit() {
    if (this.data) {
      const viewData: any = {
        follow: formatNumber(this.data.follow),
        unfollow: formatNumber(this.data.unfollow),
        new: formatNumber(this.data.new),
        compare: this.data.compare,
      };
      this.viewData = viewData;
    }
  }
}
